import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import SEO from "@/components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO title="Page Not Found" description="The page you're looking for doesn't exist." path="/404" />
      <section className="grid min-h-[80vh] place-items-center bg-navy px-6 pt-24">
        <div className="text-center">
          <div className="font-display text-[7rem] leading-none text-teal-light sm:text-[10rem]">404</div>
          <h1 className="mt-2 font-display text-3xl text-white sm:text-4xl">This page took a wrong turn.</h1>
          <p className="mx-auto mt-4 max-w-md text-white/60">Let's get you back on a clearer path.</p>
          <Link to="/">
            <Button className="mt-8 rounded-full bg-teal hover:bg-teal-dark text-white h-13 px-8">Back to Home</Button>
          </Link>
        </div>
      </section>
    </>
  );
}
